import { render, staticRenderFns } from "./recipe-dropzone.vue?vue&type=template&id=4b23e04d&"
import script from "./recipe-dropzone.vue?vue&type=script&lang=js&"
export * from "./recipe-dropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports